import { ADD_SOMATORIO, CLEAR_SOMATORIO } from '../actions/actionTypes';

const initialState = [];

export const somatorioReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_SOMATORIO:
            const somatorioSemFaccao = state.length > 0 ? state.filter(e => e.faccao !== action.somatorio.faccao) : state;
            return [...somatorioSemFaccao, action.somatorio];
        case CLEAR_SOMATORIO:
            return [];
        default:
            return state;
    }
};
